var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-chartjs-2/~/lodash/_coreJsData.js
 ** module id = 1312
 ** module chunks = 0
 **/